'use client'

import { useEffect, useRef } from 'react'
import { useAccount } from '@/domain/hooks/useAccount'
import { useOpenDialog } from '@/domain/hooks/useDialog'
import { isAddressInAlertList, wasAlertDismissed } from '@/config/walletAlerts'
import { walletAlertDialogConfig } from './WalletAlertDialog'

export function WalletAlertContainer() {
  const address = useAccount()
  const openDialog = useOpenDialog()
  const lastCheckedAddress = useRef<string | undefined>(undefined)

  useEffect(() => {
    if (!address) {
      lastCheckedAddress.current = undefined
      return
    }

    // Only check if this is a new address connection
    if (lastCheckedAddress.current?.toLowerCase() === address.toLowerCase()) {
      return
    }

    lastCheckedAddress.current = address.toLowerCase()

    // Check if address is in alert list and hasn't been dismissed
    if (isAddressInAlertList(address) && !wasAlertDismissed(address)) {
      openDialog(walletAlertDialogConfig, { walletAddress: address })
    }
  }, [address, openDialog])

  return null
}
